import * as React from 'react';

export type TEllipsisTextProps = {
	text: any;
	length: any;
	tail?: string;
	tailClassName?: string;
};

export const EllipsisText: React.FC<TEllipsisTextProps> = (props: TEllipsisTextProps) => {
	const { text, length, tail, tailClassName, ...others } = props;
	let textTail;
	let textTailClassName;

	tail ? (textTail = tail) : (textTail = '...');

	if (!tailClassName) {
		textTailClassName = 'more';
	}

	let displayText = '';
	let tailStyle = {};

	if ((text && text.length <= length) || length < 0) {
		return <span {...others}>{text}</span>;
	} else {
		tailStyle = { cursor: 'auto' };
		if (length - textTail.length <= 0) {
			displayText = '';
		} else {
			displayText = text ? text.slice(0, length - textTail.length) : '';
		}
	}

	return (
		<span title={text} {...others}>
			{displayText}
			<span style={tailStyle} className={textTailClassName}>
				{textTail}
			</span>
		</span>
	);
};
